import { render } from "./error-alert-mobile.vue?vue&type=template&id=0f25c042&scoped=true"
import script from "./error-alert-mobile.vue?vue&type=script&lang=js"
export * from "./error-alert-mobile.vue?vue&type=script&lang=js"

import "./error-alert-mobile.vue?vue&type=style&index=0&id=0f25c042&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f25c042"

export default script